Object.defineProperty(exports,"__esModule",{value:true});var _assign2=require("lodash/assign");var _assign3=_interopRequireDefault(_assign2);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=require("react");var _react2=_interopRequireDefault(_react);
var _helpers=require("../victory-util/helpers");var _helpers2=_interopRequireDefault(_helpers);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var



Candle=function(_React$Component){_inherits(Candle,_React$Component);function Candle(){_classCallCheck(this,Candle);return _possibleConstructorReturn(this,(Candle.__proto__||Object.getPrototypeOf(Candle)).apply(this,arguments));}_createClass(Candle,[{key:"renderWick",value:function renderWick(

























wickProps){
return _react2.default.createElement("line",wickProps);
}},{key:"renderCandle",value:function renderCandle(


candleProps){
return _react2.default.createElement("rect",candleProps);
}},{key:"getCandleProps",value:function getCandleProps(

props){var
width=props.width,candleHeight=props.candleHeight,x=props.x,y=props.y,data=props.data,events=props.events,role=props.role,className=props.className,datum=props.datum,active=props.active;
var style=_helpers2.default.evaluateStyle((0,_assign3.default)({stroke:"black"},props.style),datum,active);
var padding=props.padding.left||props.padding;
var candleWidth=style.width||0.5*(width-2*padding)/data.length;
var candleX=x-candleWidth/2;
var shapeRendering=props.shapeRendering||"auto";
return(0,_assign3.default)({
x:candleX,y:y,style:style,role:role,width:candleWidth,height:candleHeight,
shapeRendering:shapeRendering,className:className},
events);
}},{key:"getWickProps",value:function getWickProps(

props){var
x=props.x,y1=props.y1,y2=props.y2,events=props.events,className=props.className,datum=props.datum,active=props.active;
var style=_helpers2.default.evaluateStyle((0,_assign3.default)({stroke:"black"},props.style),datum,active);
var shapeRendering=props.shapeRendering||"auto";
var role=props.role||"presentation";
return(0,_assign3.default)({x1:x,x2:x,y1:y1,y2:y2,style:style,role:role,shapeRendering:shapeRendering,className:className},events);
}},{key:"render",value:function render()

{
var candleProps=this.getCandleProps(this.props);
var wickProps=this.getWickProps(this.props);
return _react2.default.cloneElement(
this.props.groupComponent,{},this.renderWick(wickProps),this.renderCandle(candleProps));

}}]);return Candle;}(_react2.default.Component);Candle.propTypes={active:_react.PropTypes.bool,className:_react.PropTypes.string,index:_react.PropTypes.number,x:_react.PropTypes.number,y1:_react.PropTypes.number,y2:_react.PropTypes.number,y:_react.PropTypes.number,events:_react.PropTypes.object,candleHeight:_react.PropTypes.number,shapeRendering:_react.PropTypes.string,scale:_react.PropTypes.object,style:_react.PropTypes.object,datum:_react.PropTypes.object,width:_react.PropTypes.number,padding:_react.PropTypes.oneOfType([_react.PropTypes.number,_react.PropTypes.object]),data:_react.PropTypes.array,groupComponent:_react.PropTypes.element,role:_react.PropTypes.string};exports.default=Candle;


//////////////////
// WEBPACK FOOTER
// ./~/victory-core/lib/victory-primitives/candle.js
// module id = 1264
// module chunks = 0 1